import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { isProjectScope, isReleaseGroupScope } from '../../../../shared/issuesV2';
import useOnMount from '../../../hooks/useOnMount';
import * as IssuesV2Store from '../../../redux/issuesV2';
import type { ProjectScope, ReleaseGroupScope } from '../../../../shared/issuesV2';
import type { IssuesContainerProps } from '../IssuesContainer';

import ComparisonContent from './ComparisonContent';
import EmptyState from './EmptyState';

const isEmptyComparison = (scope: ProjectScope | ReleaseGroupScope) => {
  if (isProjectScope(scope)) {
    const compare = scope.compareTo?.revision;
    return !compare || compare === scope.revision;
  }
  if (isReleaseGroupScope(scope)) {
    const compare = scope.compareTo?.release;
    return !compare || compare === scope.release;
  }
  return true;
};

const IssueComparisonContainer: VoidFunctionComponent<IssuesContainerProps> = ({
  params,
  location,
  project,
  revision,
  router,
}) => {
  const dispatch = useDispatch();

  const scope = useSelector(IssuesV2Store.selectors.getScope) as ProjectScope | ReleaseGroupScope;

  useOnMount(
    () => dispatch(IssuesV2Store.actions.enterComparisonMode()),
    () => dispatch(IssuesV2Store.actions.exitComparisonMode()),
  );

  if (isEmptyComparison(scope)) {
    return (
      <EmptyState scope={scope} />
    );
  }

  return (
    <ComparisonContent params={params} location={location} project={project} revision={revision} router={router} />
  );
};

export default IssueComparisonContainer;
